import React from "react";
import { Toggleable } from "@fishrmn/fishrmn-components";

import NavigationOverlay from "./NavigationOverlay";
import NavigationToggle from "./NavigationToggle";
import NavigationLogo from "./NavigationLogo";

const MobileNavigation = ({ currentLocation }) => (
  <Toggleable>
    {(toggle, onToggle) => (
      <div className="nav-container">
        <NavigationToggle onToggle={onToggle} />
        <NavigationLogo />
        {toggle && (
          <NavigationOverlay
            onToggle={onToggle}
            currentLocation={currentLocation}
          />
        )}
      </div>
    )}
  </Toggleable>
);

export default MobileNavigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/MobileNavigation.jsx